import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Services", id: "services" },
  { label: "Solutions", id: "solutions" },
  { label: "Industries", id: "industries" },
  { label: "Projects", id: "projects" },
  { label: "About", id: "about" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTo = (id) => {
    setOpen(false);
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 120);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 border-b ${
        scrolled ? "bg-[#0a0a0a]/85 backdrop-blur-xl border-[#1e1e1e]" : "bg-transparent border-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1200px] px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <Link to="/" data-testid="navbar-logo" className="flex items-center group">
            <img src="/brand/graphikpro-logo-dark.png" alt="Graphikpro" className="h-7 w-auto" />
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-link-${l.id}`}
                onClick={() => goTo(l.id)}
                className="rounded-full px-3.5 py-2 text-sm font-medium text-[#a7a7a7] hover:text-white hover:bg-white/5 transition-colors"
              >
                {l.label}
              </button>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <button
              data-testid="nav-consultation-btn"
              onClick={() => goTo("contact")}
              className="rounded-lg bg-white px-4 py-2 text-sm font-medium text-[#0a0a0a] hover:bg-[#15b351] hover:text-white transition-colors"
            >
              Book a Consultation
            </button>
          </div>

          <button
            data-testid="nav-mobile-toggle"
            className="md:hidden text-white"
            onClick={() => setOpen((v) => !v)}
            aria-label="Menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-[#0a0a0a] border-t border-[#1e1e1e] px-6 py-5 space-y-2">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-mobile-link-${l.id}`}
              onClick={() => goTo(l.id)}
              className="block w-full text-left rounded-lg px-3 py-2.5 text-base font-medium text-[#a7a7a7] hover:bg-white/5"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-mobile-consultation-btn"
            onClick={() => goTo("contact")}
            className="w-full rounded-lg bg-white px-5 py-3 text-sm font-medium text-[#0a0a0a]"
          >
            Book a Consultation
          </button>
        </div>
      )}
    </header>
  );
};
